import { ConfiguratorDI, Enumerable } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { Field } from "@models/configurators/field";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { RuleContainer } from "@models/configurators/rule-container";
import { Configurator } from "./configurator";

export class UiObject extends RuleContainer {

    constructor(kom: KbObjectManager, args?: { ruleType?: string }) {
        super(kom, args);
    }

    public visible: boolean;
    public left: string;
    public top: string;
    public right: string;
    public bottom: string;
    public width: string;
    public height: string;
    public opacity: number;
    public order: number;
    public relativeSize: string;
    public alignment: string;
    public $valid = true;

    public getCss(prop: string) {
        let v = this[prop];
        let numeric = (Number(v) == v);
        return numeric ? `${v}px` : v;
    }

    protected filterChildren<T extends UiObject>(tokens: CToken[], allChildren: UiObject[]): T[] {
        let list: T[] = [];
        for (let c of allChildren) {
            if (!tokens.length || tokens.some(t => ConfiguratorDI.instanceOf<T>(c, t))) {
                list.push(c as any);
            }
            c.getChildrenOfType<T>(...tokens).forEach(c2 => list.push(c2));
        }
        return list;
    }

    /**
     * 
     * @param token Gets all the UI children of the given types.
     * @param allChildren 
     */
    public getChildrenOfType<T extends UiObject>(...tokens: CToken[]): T[] {
        return [];
    }


    public allowedChildren(rootType: CToken): CToken[]{
        // implement in derived classes
        return [];
    }

    /**
     * Utility function to get all of the standard allowed elements
     * for container type parents.
     * @param rootType 
     */
    public containerChildren(rootType: CToken): CToken[]{
        if (rootType == CToken.Configurator) {
            return [
                CToken.Accordion,
                CToken.Button,
                CToken.Container,
                CToken.DropdownButton,
                CToken.Expander,
                CToken.Field,
                CToken.GridRow,
                CToken.Group,
                CToken.Html,
                CToken.SvgViewer,
                CToken.Media,
                CToken.Popup,
                CToken.TabControl,
                CToken.Text,               
                CToken.Toolbar,  
                CToken.NestedElement,
                CToken.NestedSet
            ];
        } else if (rootType == CToken.LayoutConfig) {
            return [
                CToken.ActionBar,
                CToken.Accordion,
                CToken.Button,
                CToken.Container,
                CToken.DropdownButton,
                CToken.Expander,
                //CToken.Field,
                //CToken.GridRow,
                CToken.Group,
                CToken.Html,
                CToken.SvgViewer,
                CToken.Media,
                CToken.PageNavigator,
                CToken.PageControl,
                CToken.PageTabs,
                CToken.Popup,
                CToken.PriceWidget,
                CToken.TabControl,
                CToken.Text,               
                CToken.Toolbar,  
                CToken.Viewer,
            ];
        } else {
            return [];
        }
    }

    /** calculated validity and stores result in $valid property */
    public isValid(): boolean {
        let fields = this.getChildrenOfType<Field>(CToken.Field);
        let valid = !fields.some(f => !f.isValid());
        if (!valid) {
            this.$valid = false;
            return this.$valid;
        }

        this.$valid = true;
        return this.$valid;
    }

    /**
     * get's the html id that represents this ui object in the DOM
     */
    @Enumerable()
    public get $domId(): string {
        let c = ConfiguratorDI.instanceOf<Configurator>(this, CToken.Configurator) ? this : this.$parentConfigurator;
        let p = c ? c.name.toKebabCase() + "-" : "";
        return p + this.id;
    }

}
